import { Observable } from 'rxjs';
import { LoggerService } from 'src/app/services/logger/logger.service';

export interface IPageVisibility {
	isVisible(): Promise<boolean>;
}

export abstract class PageVisibility implements IPageVisibility {
	protected abstract getSectionVisibility(): Observable<{ value: boolean; type: string }>;
	protected abstract initializeLoadedResult(): any;

	constructor(protected logger: LoggerService) {}

	public async isVisible(): Promise<boolean> {
		await this.initialize();
		this.logger.info('PageVisibility - isVisible');
		return new Promise(this.visibilityHandler.bind(this));
	}

	protected initialize(): Promise<void> {
		return Promise.resolve();
	}

	private visibilityHandler(resolve: (arg0: boolean) => void) {
		this.logger.info('visibilityHandler - visibilityHandler - Start');
		const loadedFeatures = this.initializeLoadedResult();
		const onNext = (result: { value: boolean; type: string }) => {
			this.logger.info('visibilityHandler - visibilityHandler - onNext');
			const nextResult = this.nextHandler(result, loadedFeatures);
			if (nextResult.isResolved) {
				resolve(nextResult.resolvedResult);
				sectionVisibilitySubscription.unsubscribe();
			}
		};
		const checkCapabilitiesObservable = this.getSectionVisibility();
		const sectionVisibilitySubscription = checkCapabilitiesObservable.subscribe({
			next: onNext.bind(this),
			error: () => resolve(false),
		});
		this.logger.info('visibilityHandler - visibilityHandler - End');
	}

	private nextHandler(loadResult: { value: boolean; type: string }, loadedFeatures: any) {
		let isResolved = false;
		let resolvedResult = false;

		loadedFeatures[loadResult.type] = true;
		if (loadResult.value) {
			isResolved = true;
			resolvedResult = true;
		} else {
			isResolved = this.isAllFeaturesLoaded(loadedFeatures);
		}

		const nextResult = { isResolved, resolvedResult };
		this.logger.info('PageVisibility - nextHandler', nextResult);

		return nextResult;
	}

	private isAllFeaturesLoaded(loadedFeatures: any): boolean {
		let isAllLoaded: boolean = true;
		for (let keys in loadedFeatures) {
			isAllLoaded = isAllLoaded && loadedFeatures[keys];
		}
		return isAllLoaded;
	}
}
